<template>
  <el-dialog
    title="文件"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="1250px"
    center
    append-to-body
    :before-close="beforeClose"
    @close="close"
  >
    <div class="wpsCont">
      <iframe :src="url"></iframe>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { revisionVerification } from '@/api/yozoOffice';
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    // 文件id 地址 名字
    fileData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: ''
    },
    formData: Object,
    // 操作人
    operator: {},
    // 是否可编辑
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      url: '',
      revise: true
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters(['name']),
    dialogVisible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  methods: {
    init() {
      console.log('wps组件getdate:', this.fileData);

      if (this.operator === this.name) {
        // 判断是否本人第一次打开
        revisionVerification({ fileId: this.fileData.fileId })
          .then((res) => {
            if (res.data === 'true' || res.data === true) {
              this.revise = false;
            } else {
              this.revise = true;
            }
            this.$nextTick((_) => {
              this.openYozo();
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.revise = true;
        this.$nextTick((_) => {
          this.openYozo();
        });
      }
    },
    openYozo() {
      let data = {
        method: 1,
        params: {
          userId: this.name,
          fileId: this.fileData.fileId,
          filePath: this.fileData.filePath,
          fileName: this.fileData.fileName,
          callbackUrl:
            DisciplineConfig.BASE_API + '/yozoOffice/callbackAttachFile.do',
          userRight: this.isEdit ? '0' : '1', // 是否可编辑
          extraData: { revise: this.revise, markup: '0' }, // revise：true 开启修订 ；markup： 0无标记  2显示标记
          userMenuPermission:
            '{"re_view":0,"yozo_WP_reviseView":0,"yozo_WP_reviseAccept":0,"yozo_WP_reviseRefuse":0,"yozo_WP_limitedit":0,"historyMark":0}'
        }
      };
      console.log('openYozo-param:', JSON.stringify(data));
      let s = this.fileData.fileName.substring(
        this.fileData.fileName.lastIndexOf('.') + 1
      );
      if (s === 'pdf') {
        $.ajax({
          url: DisciplineConfig.yozoUrl,
          data: {
            convertType: 20,
            downloadUrl: this.fileData.filePath,
            acceptTracks: true
          },
          type: 'POST',
          dataType: 'json',
          general: false,
          async: true,
          success: (data) => {
            this.url = data.data[0];
          }
        });
      } else {
        $.ajax({
          // url: DisciplineConfig.ARK_OFFICE_HOST + '/api.do',
          url: DisciplineConfig.ARK_OFFICE_HOST,
          // data: {
          //   jsonParams: encodeURIComponent(JSON.stringify(data))
          // },
          data: {
            convertType: 0,
            downloadUrl: this.fileData.filePath,
            acceptTracks: true
          },
          type: 'POST',
          dataType: 'json',
          general: false,
          async: true,
          success: (data) => {
            this.url = data.data[0];
            // if (data.errorCode === '0') {
            //   let rst = data.result;
            //   if (rst && rst.urls) {
            //     this.url = rst.urls;
            //     console.log('文件地址', rst.urls);
            //   } else {
            //     console.warn('ajaxxxx' + rst);
            //   }
            // } else {
            //   this.$message.error('文档加载失败');
            // }
          }
        });
      }
    },
    close() {
      this.$emit('close');
    },
    // beforeClose(done) {
    //   if (!this.url) {
    //     done();
    //     return false;
    //   }
    //   let data = {
    //     fileId: this.fileData.fileId
    //   };
    //   let s = this.fileData.fileName.substring(
    //     this.fileData.fileName.lastIndexOf('.') + 1
    //   );
    //   if (s === 'pdf') {
    //     done();
    //   } else {
    //     $.ajax({
    //     url: DisciplineConfig.ARK_OFFICE_HOST + '/closeFile.do',
    //     data,
    //     type: 'POST',
    //     dataType: 'json',
    //     general: false,
    //     async: false,
    //     success: (data) => {
    //       if (data && data.errorCode === '0') {
    //         console.log('文件保存成功！');
    //         done();
    //       } else {
    //         this.$message.error('文件保存失败');
    //         done();
    //       }
    //     },
    //     error: (err) => {
    //       this.$message.error('文件保存失败');
    //       done();
    //     }
    //   });
    //   }
    // }
  }
};
</script>
<style scoped lang="less">
.wpsCont {
  height: calc(100vh - 80px);
  width: 100%;

  > iframe {
    height: 100%;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/office/wps.vue